
// ─── Experience ─────────────────────────────────────────────────────────────────────
export const experienceList = [
  {
    title: "Junior Member of technical staff",
    titleFr: "Membre junior du personnel technique",
    company: "Oracle",
    date: "Sep. 2025 - Present",
  },
  {
    title: "Research Assistant",
    titleFr: "Assistant de recherche",
    company: "Oracle",
    date: "Mar. 2025 - Sep. 2025",
  },
  {
    title: "Full Stack Developer Intern",
    titleFr: "Stagiaire développeur full stack",
    company: "ABA Technology (Nextronic)",
    date: "Jul. 2024 - Aug. 2024",
  },
  {
    title: "AI Research Intern",
    titleFr: "Stagiaire recherche en IA",
    company: "ABA Technology (Nextronic)",
    date: "Jul. 2023 - Sep. 2023",
  },
];

// ─── Certificates ─────────────────────────────────────────────────────────────
export const certificates = [
  {
    title:
      "Building Scalable Java Microservices with Spring Boot and Spring Cloud",
    issuer: "Google",
    issued: "Nov. 2024",
    id: "10ZTKWF5QUFW",
    image: "/img/certificates/microservices.png",
  },
  {
    title: "Oracle Cloud Infrastructure 2025 Foundations Associate",
    issuer: "Oracle",
    issued: "Apr. 2025",
    image: "/img/certificates/cloud.png",
  },
  {
    title: "Oracle Cloud Infrastructure 2025 AI Foundations Associate",
    issuer: "Oracle",
    issued: "JAN. 2026",
    image: "/img/certificates/ai_foundations.png",
  },
  {
    title: "Oracle Certified Associate, Java SE 8 Programmer",
    issuer: "Oracle",
    issued: "JUN. 2026",
    image: "/img/certificates/java_se_9.png",
  },
  {
    title: "JNJD Participation Certificate",
    issuer: "CIT INPT",
    issued: "May 2024",
    image: "/img/certificates/jnjd.png",
  },
  {
    title: "MNPC Participation Certificate",
    issuer: "MNPC Moroccan National Programming Contest",
    issued: "Feb. 2024",
    image: "/img/certificates/mnpc.png",
  },
  {
    title: "Introduction to Git and GitHub",
    issuer: "Google",
    issued: "Apr. 2024",
    id: "5N694MM7Q77C",
    image: "/img/certificates/git.png",
  },
  {
    title: "Introduction to Containers w/ Docker, Kubernetes & OpenShift",
    issuer: "IBM",
    issued: "Apr. 2024",
    id: "85JMXPS7B6DW",
    image: "/img/certificates/k8s.png",
    skills: ["Openshift", "Kubernetes"],
  },
  {
    title: "Software Engineering: Modeling Software Systems using UML",
    issuer: "The Hong Kong University of Science and Technology",
    issued: "Apr. 2023",
    id: "TR4C9ADB4WRP",
    image: "/img/certificates/uml.png",
  },
  {
    title: "React Native",
    issuer: "Meta",
    issued: "Mar. 2024",
    id: "GGUJ6Q3EFJFL",
    image: "/img/certificates/react_native.png",
  },
  {
    title: "DevOps, Cloud, and Agile Foundations",
    issuer: "IBM",
    issued: "Mar. 2024",
    id: "67XKXHGR3KGH",
    image: "/img/certificates/devops.png",
  },
  {
    title: "Java and Object-Oriented Programming",
    issuer: "University of Pennsylvania",
    issued: "Dec. 2023",
    id: "GYMDY5AXFNAR",
    image: "/img/certificates/oop.png",
  },
  {
    title: "Python Data Structures",
    issuer: "University of Michigan",
    issued: "Mar. 2023",
    id: "MRJQLHSRVF8Y",
    image: "/img/certificates/data_structures.png",
  },
  {
    title: "CSharp and .NetCore / SQL SERVER",
    issuer: "Bright Coding",
    issued: "Jul. 2022",
  },
  {
    title: "React Basics",
    issuer: "Meta",
    issued: "Nov. 2023",
    id: "3PHHJ995KMCH",
    image: "/img/certificates/basics.png",
  },
  {
    title: "Javascript Course",
    issuer: "Bright Coding",
    issued: "Jul. 2021",
    id: "5D2C3D28",
  },
];
// ─── Study path ─────────────────────────────────────────────────────────────────────
export const studyPath = [
  {
    date: "2024-2025",
    title: "Double degree in Artificial Intelligence and Computer Science",
    titleFr: "Double diplôme en intelligence artificielle et informatique",
    school: "Côte d'Azur University, France",
  },
  {
    date: "2020-2025",
    title: "Engineer's degree, Computer Software Engineering",
    titleFr: "Diplôme d'ingénieur en génie logiciel",
    school: "Moroccan School of Engineering Sciences (EMSI), Morocco",
    schoolFr: "École Marocaine des Sciences de l'Ingénieur (EMSI), Maroc",
  },
  {
    date: "2019-2020",
    title: "baccalaureate Degree in physical sciences",
    titleFr: "Baccalauréat en sciences physiques",
    school: "Nour El Khalil High School, Morocco",
    schoolFr: "Lycée Nour El Khalil, Maroc",
  },
];

// ─── Blog ────────────────────────────────────────────────────────────────────

export const blogList = [
    {
      id: "monkeypatching",
      date: "2026-04-14", 
      title: "Monkey patching with preservation",
      titleFr: "Monkey patching avec préservation",
    }
]

export const blogPosts = {
  monkeypatching: {
    id: "monkeypatching",
    date: "2026-04-14",
    title: "Monkey patching with preservation",
    titleFr: "Monkey patching avec préservation",
    body: [
      {
        img: {
          src: "/img/monkey2.jpg",
          alt: "StreamCinet UI",
          caption: "StreamCinet App interface",
          width: "400px",
        }
      },

      {
        p: "I was coding a project called diagterm an idea that came to me to build a CLI tool that displays system information in a structured and interactive way. While building it, I noticed I was repeating the same try/catch error handling everywhere. That felt wrong because it breaks the DRY (Don't Repeat Yourself) principle. So I started searching for a better solution, and I discovered something called monkey patching."
      },

      {
        p: "Monkey patching is a technique where you modify or replace functions or behaviors of existing code at runtime without changing its original source. At first it sounds dangerous, but when used correctly, it becomes a very powerful tool for controlling execution flow."
      },

      {
        code: {
          lang: "javascript",
          title: "basic monkey patching example",
          content: `const ex = {
  greatness() {
    console.log("You are great");
  }
};

// monkey patch (modify behavior at runtime)
ex.greatness = function () {
  console.log("You are greater than before");
};

ex.greatness();`
        }
      },

      {
        p: "This simple idea becomes extremely powerful when applied to real-world problems like logging, error handling, performance tracking, and even security validation."
      },

      {
        p: "One of the first powerful uses I discovered was logging interception. Instead of manually adding logs everywhere, you can patch console.log globally and inject behavior automatically."
      },

      {
        code: {
          lang: "javascript",
          title: "logging interception",
          content: `const originalLog = console.log;

console.log = function (...args) {
  originalLog("[LOG]:", ...args);
};
// this will print [LOG]: Hello world
console.log("Hello world");`
        }
      },

      {
        p: "This same idea is used in real production systems for debugging tools, analytics tracking, and observability layers."
      },

      {
        p: "Another powerful use is error handling. In my diagterm project, instead of repeating try/catch in every command, I wrapped actions globally so every command automatically becomes safe."
      },

      {
        code: {
          lang: "javascript",
          title: "safe action wrapper",
          content: `const safeAction = (fn) => async function (...args) {
  try {
    await fn.apply(this, args);
  } catch (err) {
    console.error("Error:", err.stack || err.message);
  }
};`
        }
      },

      {
        p: "Monkey patching is also used for performance measurement. You can wrap any function and measure execution time without modifying its internal logic."
      },

      {
        code: {
          lang: "javascript",
          title: "performance tracking",
          content: `const originalTask = heavyTask;

heavyTask = function (...args) {
  const start = performance.now();

  const result = originalTask.apply(this, args);

  const end = performance.now();
  console.log(\`Execution time: \${end - start}ms\`);

  return result;
};`
        }
      },

      {
        p: "Another real-world use case is input validation. You can intercept function calls and enforce rules before executing the original logic."
      },

      {
        code: {
          lang: "javascript",
          title: "security / validation layer",
          content: `const originalTransfer = bank.transfer;

bank.transfer = function (amount) {
  if (amount > 10000) {
    throw new Error("Limit exceeded");
  }

  return originalTransfer.call(this, amount);
};`
        }
      },

      {
        p: "Monkey patching is also used in A/B testing and feature toggles. You can dynamically change behavior depending on environment variables without touching the original codebase."
      },

      {
        p: "But the most important lesson I learned is that monkey patching is powerful but dangerous if overused. It hides behavior, can make debugging harder, and may break when libraries update. It should be used carefully, only when it truly improves structure or removes repetition."
      },

      {
        p: "In my case, it helped me transform a messy CLI full of repeated try/catch blocks into a clean system where error handling is centralized and automatic. That's when I realized monkey patching is not just a trick; it's a form of runtime control over program behavior."
      }
    ],
    bodyFr: [
      {
        img: {
          src: "/img/monkey2.jpg",
          alt: "Monkey patching",
          caption: "Monkey patching illustration",
          width: "400px",
        }
      },

      {
        p: "Je codais un projet appelé diagterm, une idée que j'ai eue pour construire un outil CLI qui affiche les informations système de façon structurée et interactive. Pendant le développement, j'ai remarqué que je répétais les mêmes blocs try/catch partout. Ce n'était pas propre, car cela casse le principe DRY. J'ai donc cherché une meilleure solution, et j'ai découvert le monkey patching."
      },

      {
        p: "Le monkey patching est une technique qui consiste à modifier ou remplacer le comportement de fonctions existantes pendant l'exécution, sans changer leur code source original. Au début cela peut sembler dangereux, mais bien utilisé, cela devient un outil puissant pour contrôler le flux d'exécution."
      },

      {
        code: {
          lang: "javascript",
          title: "exemple simple de monkey patching",
          content: `const ex = {
  greatness() {
    console.log("You are great");
  }
};

// monkey patch (modify behavior at runtime)
ex.greatness = function () {
  console.log("You are greater than before");
};

ex.greatness();`
        }
      },

      {
        p: "Cette idée simple devient très puissante dans des cas réels comme les logs, la gestion d'erreurs, la mesure de performance, ou même la validation de sécurité."
      },

      {
        p: "Un des premiers usages utiles que j'ai decouverts est l'interception des logs. Au lieu d'ajouter des logs manuellement partout, on peut patcher console.log globalement et injecter automatiquement un comportement."
      },

      {
        code: {
          lang: "javascript",
          title: "interception des logs",
          content: `const originalLog = console.log;

console.log = function (...args) {
  originalLog("[LOG]:", ...args);
};
// this will print [LOG]: Hello world
console.log("Hello world");`
        }
      },

      {
        p: "La même idée est utilisée dans de vrais systèmes de production pour le débogage, l'analytics et l'observabilité."
      },

      {
        p: "Un autre usage important est la gestion d'erreurs. Dans mon projet diagterm, au lieu de répéter try/catch dans chaque commande, j'ai enveloppé les actions globalement pour que chaque commande devienne automatiquement plus sûre."
      },

      {
        code: {
          lang: "javascript",
          title: "wrapper d'action sécurisé",
          content: `const safeAction = (fn) => async function (...args) {
  try {
    await fn.apply(this, args);
  } catch (err) {
    console.error("Error:", err.stack || err.message);
  }
};`
        }
      },

      {
        p: "Le monkey patching peut aussi servir à mesurer les performances. On peut envelopper une fonction et mesurer son temps d'exécution sans modifier sa logique interne."
      },

      {
        code: {
          lang: "javascript",
          title: "suivi des performances",
          content: `const originalTask = heavyTask;

heavyTask = function (...args) {
  const start = performance.now();

  const result = originalTask.apply(this, args);

  const end = performance.now();
  console.log(\`Execution time: \${end - start}ms\`);

  return result;
};`
        }
      },

      {
        p: "Un autre cas reel est la validation des entrees. On peut intercepter les appels de fonction et appliquer des regles avant d'executer la logique originale."
      },

      {
        code: {
          lang: "javascript",
          title: "couche de sécurité / validation",
          content: `const originalTransfer = bank.transfer;

bank.transfer = function (amount) {
  if (amount > 10000) {
    throw new Error("Limit exceeded");
  }

  return originalTransfer.call(this, amount);
};`
        }
      },

      {
        p: "Le monkey patching est aussi utilise pour les tests A/B et les feature toggles. On peut changer un comportement dynamiquement selon des variables d'environnement sans toucher au code original."
      },

      {
        p: "La leçon la plus importante est que le monkey patching est puissant mais dangereux s'il est trop utilisé. Il peut cacher le comportement, compliquer le débogage et casser lors de mises à jour de bibliothèques. Il faut l'utiliser avec soin, seulement lorsqu'il améliore vraiment la structure ou évite une répétition inutile."
      },

      {
        p: "Dans mon cas, il m'a aidé à transformer une CLI confuse, pleine de try/catch répétés, en un système plus propre où la gestion d'erreurs est centralisée et automatique. C'est là que j'ai compris que le monkey patching n'est pas juste une astuce, mais une façon de contrôler le comportement d'un programme à l'exécution."
      }
    ],
    links: []
  }
};
// ─── Home ────────────────────────────────────────────────────────────────────

export const skills = [
  {
    label: "Languages",
    text: "JavaScript, TypeScript, Python, SQL, HTML & CSS",
  },
  {
    label: "Frameworks & Libraries",
    text: "React, Next.js, Node.js, FastAPI, Tailwind CSS",
  },
  {
    label: "Tools & Infrastructure",
    text: "Git, Docker, AWS, PostgreSQL, Redis, Figma",
  },
];

// ─── Work ────────────────────────────────────────────────────────────────────

export const workList = [
  {
    id: "streamcinet",
    year: "2024",
    title: "StreamCinet App movie and series tracking application",
    titleFr: "Application StreamCinet de suivi de films et séries",
    subtitle: "C++/CLI, CURL, TMDB API",
  },
  {
    id: "leetcodeextension",
    year: "2025",
    title: "LeetCode Extension for Chrome",
    titleFr: "Extension Chrome pour LeetCode",
    subtitle: "JavaScript, Chrome Extensions API, GitHub API",
  },
  {
    id: "lispyinterpreter",
    year: "2025",
    title: "A simple Lisp interpreter in Python",
    titleFr: "Un interpréteur Lisp simple en Python",
    subtitle: "Python",
  },
  {
    id: "laundrywebsite",
    year: "2025",
    title: "Laundry website",
    titleFr: "Site web de pressing",
    subtitle: "React, Firebase, Tailwind CSS",
  },
  {
    id: "springify",
    year: "2025",
    title: "Springify UML",
    subtitle: "Java Spring Boot, React, Gemini API, MySQL, Docker",
  },
  { id: "wolfman", year: "2025", title: "P5.js Game", titleFr: "Jeu P5.js", subtitle: "P5.js" },
  {
    id: "fusebox",
    year: "2025",
    title: "FuseBox management system",
    titleFr: "Système de gestion FuseBox",
    subtitle: "React, Node.js, Express.js, MongoDB, OpenCV, YOLOv8, Tailwind CSS",
  },
  {
    id: "informationret",
    year: "2025",
    title: "Information Retrieval System",
    titleFr: "Système de recherche d'information",
    subtitle: "Python, Spacy, DbPedia, SPARQL",
  },
];
/**
 * Project body uses a lightweight DSL - one key per block type:
 *
 *   { p:   "paragraph text" }
 *   { h3:  "section heading" }
 */
export const projects = {
  streamcinet: {
    title: "StreamCinet App",
    titleFr: "Application StreamCinet",
    year: "2024",
    links: [["GitHub", "https://github.com/Hamza-ouabiba/streamCinet-App"]],
    technologies: ["C++/CLI", "CURL", "TMDB API"],
    body: [
      {
        img: {
          src: "/img/streamcinet.png",
          alt: "StreamCinet UI",
          caption: "StreamCinet App interface",
          width: "600px",
        },
      },
      {
        p: `This application is a movie and series tracking application built in C++/CLI and CURL,
            which uses the TMDB API to retrieve data and display it in the app. The user can view
            all the information about a specific movie or series, and also has the option to add
            it to their library or calendar.`,
      },
      {
        code: {
          lang: "bash",
          title: "Github clone url",
          content: `git clone https://github.com/Hamza-ouabiba/streamCinet-App.git`,
        },
      }
    ],
    bodyFr: [
      {
        img: {
          src: "/img/streamcinet.png",
          alt: "Interface StreamCinet",
          caption: "Interface de l'application StreamCinet",
          width: "600px",
        },
      },
      {
        p: `Cette application permet de suivre des films et des séries. Elle est construite avec C++/CLI et CURL,
            et utilise l'API TMDB pour récupérer les données et les afficher dans l'application. L'utilisateur peut
            consulter toutes les informations d'un film ou d'une série, puis l'ajouter à sa bibliothèque ou à son calendrier.`,
      },
      {
        code: {
          lang: "bash",
          title: "URL de clonage GitHub",
          content: `git clone https://github.com/Hamza-ouabiba/streamCinet-App.git`,
        },
      }
    ],
  },
  leetcodeextension: {
    title: "LeetCode Extension",
    titleFr: "Extension LeetCode",
    year: "2025",
    links: [["GitHub", "https://github.com/Hamza-ouabiba/leetcode-extension"]],
    technologies: ["JavaScript", "Chrome Extensions API", "GitHub API"],
    body: [
      {
        img: {
          src: "/img/leetcode.png",
          alt: "LeetCode Extension UI",
          caption: "LeetCode Extension interface",
          width: "600px",
        },
      },
      {
        p: `A Chrome extension that automatically pushes LeetCode problems to your GitHub repo as you solve them.
        I built it to keep a better record of my problem-solving progress and to share my solutions on GitHub.`,
      },
      {
        p: `Built with pure JavaScript and the Chrome Extensions API. The extension listens for changes in the
            LeetCode problem page, extracts the problem details and your solution code, and then commits it to
            a GitHub repository using the GitHub API.`,
      },
      {
        code: {
          lang: "bash",
          title: "Github clone url",
          content: `git clone https://github.com/Hamza-ouabiba/leetcode-extension.git`,
        },
      }
    ],
    bodyFr: [
      {
        img: {
          src: "/img/leetcode.png",
          alt: "Interface de l'extension LeetCode",
          caption: "Interface de l'extension LeetCode",
          width: "600px",
        },
      },
      {
        p: `Une extension Chrome qui pousse automatiquement les problèmes LeetCode vers un dépôt GitHub pendant que je les résous.
        Je l'ai créée pour mieux suivre ma progression et partager mes solutions sur GitHub.`,
      },
      {
        p: `Elle est construite en JavaScript pur avec l'API des extensions Chrome. L'extension écoute les changements sur
            la page d'un problème LeetCode, extrait les détails du problème et le code de la solution, puis les commit
            dans un dépôt GitHub avec l'API GitHub.`,
      },
      {
        code: {
          lang: "bash",
          title: "URL de clonage GitHub",
          content: `git clone https://github.com/Hamza-ouabiba/leetcode-extension.git`,
        },
      }
    ],
  },
  springify: {
    title: "Springify UML",
    year: "2025",
    links: [["GitHub", "https://github.com/OptimAIzed/springify"]],
    technologies: ["Java Spring Boot", "React", "Gemini API", "MySQL", "Docker"],
    body: [
      {
        img: {
          src: "/img/springify.png",
          alt: "Springify UI",
          caption: "Springify UML interface",
          width: "600px",
        },
      },
      {
        p: `Springify UML is a powerful tool that simplifies getting your Spring Boot projects started.
            Forget tedious configurations and basic templates! Springify UML lets you precisely define
            your project's characteristics and generate structured, ready-to-use code, all in just a few clicks.`,
      },
      {
        code: {
          lang: "bash",
          title: "Github clone url",
          content: `git clone https://github.com/OptimAIzed/Springify.git`,
        },
      }
    ],
    bodyFr: [
      {
        img: {
          src: "/img/springify.png",
          alt: "Interface Springify",
          caption: "Interface de Springify UML",
          width: "600px",
        },
      },
      {
        p: `Springify UML est un outil qui simplifie le démarrage de projets Spring Boot.
            Il évite les configurations répétitives et les modèles trop basiques. Springify UML permet de définir
            précisément les caractéristiques d'un projet et de générer un code structuré et prêt à l'emploi en quelques clics.`,
      },
      {
        code: {
          lang: "bash",
          title: "URL de clonage GitHub",
          content: `git clone https://github.com/OptimAIzed/Springify.git`,
        },
      }
    ],
  },
  lispyinterpreter: {
    title: "Lisp Interpreter",
    titleFr: "Interpréteur Lisp",
    year: "2025",
    links: [["GitHub", "https://github.com/Hamza-ouabiba/mini-interpreter"]],
    technologies: ["Python"],
    body: [
      {
        p: `A simple Lisp interpreter implemented in Python. It supports basic arithmetic, variable assignment,
            and function definitions. The goal was to understand how interpreters work under the hood and to
            have fun implementing a language from scratch.`,
      },
      {
        h3: "Example usage",
      },
      {
        code: {
          lang: "lisp",
          content: `
(def fib (n)
    (if (le n 0)
    (then 0)
    (else (+ n (call fib (- n 1))))))
(call fib 5)
            `,
        },
      },
      {
        code: {
          lang: "bash",
          title: "Github clone url",
          content: `git clone https://github.com/Hamza-ouabiba/mini-interpreter.git`,
        },
      },
      {
        p: `The example above defines a recursive function to calculate Fibonacci numbers and then calls
            it with an argument of 5. The interpreter correctly evaluates the expression and returns the
            result. Which is 15, since this implementation defines fib(0) as 0 and fib(n) as n + fib(n-1) for n > 0.`,
      }
    ],
    bodyFr: [
      {
        p: `Un interpréteur Lisp simple implémenté en Python. Il prend en charge l'arithmétique de base,
            l'affectation de variables et les définitions de fonctions. L'objectif était de comprendre le fonctionnement
            interne des interpréteurs et de m'amuser à créer un langage à partir de zéro.`,
      },
      {
        h3: "Exemple d'utilisation",
      },
      {
        code: {
          lang: "lisp",
          content: `
(def fib (n)
    (if (le n 0)
    (then 0)
    (else (+ n (call fib (- n 1))))))
(call fib 5)
            `,
        },
      },
      {
        code: {
          lang: "bash",
          title: "URL de clonage GitHub",
          content: `git clone https://github.com/Hamza-ouabiba/mini-interpreter.git`,
        },
      },
      {
        p: `L'exemple ci-dessus définit une fonction récursive pour calculer des nombres de Fibonacci, puis l'appelle
            avec l'argument 5. L'interpréteur évalue correctement l'expression et retourne le résultat. Ici, le résultat
            est 15, car cette implémentation définit fib(0) comme 0 et fib(n) comme n + fib(n-1) pour n > 0.`,
      }
    ],
  },
  laundrywebsite: {
    title: "Laundry Website",
    titleFr: "Site web de pressing",
    year: "2025",
    links: [["private", "#"]],
    technologies: ["React", "Firebase", "Tailwind CSS"],
    body: [
      {
        img: {
          src: [
            "/img/pressing1.png",
            "/img/pressing2.png",
            "/img/pressing3.png",
            "/img/pressing4.png",
            "/img/pressing5.png",
            "/img/pressing6.png",
            "/img/pressing7.png",
            "/img/pressing8.png",
          ],
          alt: "Laundry website UI",
          caption: "Laundry website interface",
          width: "700px",
        },
      },
      {
        p: `A website for a laundry business. It allows customers to schedule pickups and deliveries,
            view pricing and services. Built with React for the frontend and Firebase for the backend.`,
      }
    ],
    bodyFr: [
      {
        img: {
          src: [
            "/img/pressing1.png",
            "/img/pressing2.png",
            "/img/pressing3.png",
            "/img/pressing4.png",
            "/img/pressing5.png",
            "/img/pressing6.png",
            "/img/pressing7.png",
            "/img/pressing8.png",
          ],
          alt: "Interface du site de pressing",
          caption: "Interface du site web de pressing",
          width: "700px",
        },
      },
      {
        p: `Un site web pour une activité de pressing. Il permet aux clients de planifier les collectes et les livraisons,
            de consulter les tarifs et de découvrir les services proposés. Le frontend est construit avec React et le backend avec Firebase.`,
      }
    ],
  },
  wolfman: {
    title: "Wolfman Game",
    titleFr: "Jeu Wolfman",
    year: "2025",
    links: [
      ["GitHub", "https://github.com/Hamza-ouabiba/wolfman"],
      ["Live Demo", "https://hamza-ouabiba.github.io/wolfman/"],
    ],
    technologies: ["P5.js"],
    body: [
      {
        img: {
          src: "/img/wolfman.png",
          alt: "Wolfman Game UI",
          caption: "Wolfman Game interface",
          width: "630px",
        },
      },
      {
        p: `A simple 2D game built with P5.js where you play as a wolfman trying to survive in a forest.
            You have to avoid obstacles and fight off Arthur while he hunts you down.`,
      },
      {
        code: {
          lang: "bash",
          title: "Github clone url",
          content: `git clone https://github.com/Hamza-ouabiba/wolfman.git`,
        },
      }
    ],
    bodyFr: [
      {
        img: {
          src: "/img/wolfman.png",
          alt: "Interface du jeu Wolfman",
          caption: "Interface du jeu Wolfman",
          width: "630px",
        },
      },
      {
        p: `Un jeu 2D simple construit avec P5.js, où l'on incarne un wolfman qui tente de survivre dans une forêt.
            Il faut éviter les obstacles et affronter Arthur pendant qu'il vous traque.`,
      },
      {
        code: {
          lang: "bash",
          title: "URL de clonage GitHub",
          content: `git clone https://github.com/Hamza-ouabiba/wolfman.git`,
        },
      }
    ],
  },
  fusebox: {
    title: "FuseBox Management System",
    titleFr: "Système de gestion FuseBox",
    year: "2025",
    links: [["private", "#"]],
    technologies: ["React", "Flask", "Sequelize", "MySQL", "OpenCV", "YOLOv8", "Tailwind CSS"],
    body: [
      {
        img: {
          src: ["/img/fusebox.png", "/img/fusebox2.png"],
          alt: "FuseBox UI",
          caption: "FuseBox management system interface",
          width: "700px",
        },
      },
      {
        p: `This project is a comprehensive solution for inspecting fuse boxes during the assembly phase using deep
            learning and computer vision techniques. The application allows users to upload images of fuse boxes,
            which are then analyzed by a trained deep learning model to detect any defects or issues.
            The system provides real-time feedback on the quality of the fuse box assembly,
            helping to ensure that only properly assembled units proceed to the next stage of production.`,
      },
      {
        p: "Along with that i made in place a management system to keep track of the fuse boxes and their inspection results.",
      }
    ],
    bodyFr: [
      {
        img: {
          src: ["/img/fusebox.png", "/img/fusebox2.png"],
          alt: "Interface FuseBox",
          caption: "Interface du système de gestion FuseBox",
          width: "700px",
        },
      },
      {
        p: `Ce projet est une solution complète pour inspecter des boîtes à fusibles pendant la phase d'assemblage,
            en utilisant des techniques de deep learning et de vision par ordinateur. L'application permet aux utilisateurs
            d'importer des images de boîtes à fusibles, qui sont ensuite analysées par un modèle entraîné afin de détecter
            les défauts ou les problèmes éventuels. Le système fournit un retour en temps réel sur la qualité de l'assemblage,
            ce qui aide à garantir que seules les unités correctement assemblées passent à l'étape suivante de production.`,
      },
      {
        p: "J'ai également mis en place un système de gestion pour suivre les boîtes à fusibles et leurs résultats d'inspection.",
      }
    ],
  },
  informationret: {
    title: "Information Retrieval System",
    titleFr: "Système de recherche d'information",
    year: "2025",
    links: [
      ["GitHub", "https://github.com/Hamza-ouabiba/information-retrieval"],
    ],
    technologies: ["Python", "Spacy", "DbPedia", "SPARQL"],
    body: [
      {
        img: {
          src: ["/img/ir1.png", "/img/ir2.png"],
          alt: "Information Retrieval System",
          caption: "Information Retrieval System interface",
          width: "400px",
        },
      },
      {
        p: `This project implements a rule-based Question Answering (QA) system that automatically answers natural language
            questions by querying DBpedia, a structured semantic knowledge base derived from Wikipedia.
            The system bridges the gap between human language and structured data by combining Natural
            Language Processing (NLP) techniques with Semantic Web technologies.`,
      },
      {
        h3: "How it works",
      },
      {
        p: `1. Question Understanding: The input question is analyzed using spaCy, a state-of-the-art NLP library,
            to extract named entities (people, places, organizations, etc.) and identify the main subject of the question.`,
      },
      {
        p: "2. Entity Linking: Extracted entities are matched to their corresponding DBpedia resources using the DBpedia Lookup API. Candidate URIs are ranked and selected using Levenshtein distance (for spelling similarity) and WordNet semantic similarity, ensuring the most relevant resource is chosen even when names don't match exactly.",
      },
      {
        p: '3. Relation Identification: The system fetches all properties associated with the identified DBpedia entity, then uses a hybrid matching strategy combining token-level comparison, lemmatization, synonym expansion via WordNet, and Levenshtein distance to identify which DBpedia property best corresponds to what the question is asking about (e.g., mapping "cross" to dbo:crosses, or "founded" to dbo:foundedBy).',
      },
      {
        p: "4. Answer Type Detection: Regular expressions analyze the question's structure to determine the expected answer format whether it's a date, number, string, or URI, enabling more precise result filtering.",
      },
      {
        p: "5. SPARQL Query Generation and Execution: A SPARQL query is dynamically constructed and executed against the DBpedia SPARQL endpoint, retrieving the answer directly from the knowledge base.",
      },
      {
        p: "6. Result Normalization and Filtering: Raw SPARQL results are normalized and filtered according to the detected answer type to produce clean, human-readable answers.",
      },
      {
        code: {
          lang: "bash",
          title: "Github clone url",
          content: `git clone https://github.com/Hamza-ouabiba/information-retrieval.git`,
        },
      }
    ],
    bodyFr: [
      {
        img: {
          src: ["/img/ir1.png", "/img/ir2.png"],
          alt: "Système de recherche d'information",
          caption: "Interface du système de recherche d'information",
          width: "400px",
        },
      },
      {
        p: `Ce projet implémente un système de question-réponse basé sur des règles, capable de répondre automatiquement
            à des questions en langage naturel en interrogeant DBpedia, une base de connaissances sémantique structurée issue de Wikipedia.
            Le système fait le lien entre le langage humain et les données structurées en combinant des techniques de traitement
            automatique du langage naturel avec les technologies du Web sémantique.`,
      },
      {
        h3: "Fonctionnement",
      },
      {
        p: `1. Compréhension de la question : la question saisie est analysée avec spaCy, une bibliothèque NLP reconnue,
            afin d'extraire les entités nommées et d'identifier le sujet principal de la question.`,
      },
      {
        p: "2. Liaison d'entités : les entités extraites sont associées aux ressources DBpedia correspondantes grâce à l'API DBpedia Lookup. Les URI candidates sont classées avec la distance de Levenshtein et la similarité sémantique WordNet, afin de choisir la ressource la plus pertinente même lorsque les noms ne correspondent pas exactement.",
      },
      {
        p: "3. Identification de la relation : le système récupère toutes les propriétés liées à l'entité DBpedia identifiée, puis utilise une stratégie hybride combinant comparaison de tokens, lemmatisation, expansion par synonymes WordNet et distance de Levenshtein pour trouver la propriété DBpedia qui correspond le mieux à la question.",
      },
      {
        p: "4. Détection du type de réponse : des expressions régulières analysent la structure de la question pour déterminer le format attendu de la réponse, qu'il s'agisse d'une date, d'un nombre, d'une chaîne de caractères ou d'un URI.",
      },
      {
        p: "5. Génération et exécution SPARQL : une requête SPARQL est construite dynamiquement puis exécutée sur l'endpoint SPARQL de DBpedia afin de récupérer directement la réponse depuis la base de connaissances.",
      },
      {
        p: "6. Normalisation et filtrage des résultats : les résultats bruts de SPARQL sont normalisés et filtrés selon le type de réponse détecté afin de produire une réponse propre et lisible.",
      },
      {
        code: {
          lang: "bash",
          title: "URL de clonage GitHub",
          content: `git clone https://github.com/Hamza-ouabiba/information-retrieval.git`,
        },
      }
    ],
  },
};
